// Dados mockados para o sistema
export const meses = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

export const anos = [2024, 2025, 2026, 2027];

// Meta: R$ 25.000.000,00
// 75% da meta: R$ 18.750.000,00
// Valores ajustados para totalizar exatamente 75% da meta

export const corretoresIniciais = [
  {
    id: 1,
    nome: 'Mariana Marques',
    email: 'mariana.marques@imobiliaria.com',
    telefone: '(11) 99999-9999',
    creci: 'CRECI-12345',
    foto: 'https://i.pravatar.cc/150?img=47',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 3500.50,
        Fevereiro: 1000,
        Março: 165,
        Abril: 14000,
        Maio: 1800,
        Junho: 2000,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 2,
    nome: 'Nicolas Ferreira',
    email: 'nicolas.ferreira@imobiliaria.com',
    telefone: '(11) 88888-8888',
    creci: 'CRECI-12346',
    foto: 'https://i.pravatar.cc/150?img=12',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 3000.50,
        Fevereiro: 100,
        Março: 1000,
        Abril: 157500,
        Maio: 1700,
        Junho: 2020,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 3,
    nome: 'Juliana Martins',
    email: 'juliana.martins@imobiliaria.com',
    telefone: '(11) 77777-7777',
    creci: 'CRECI-12347',
    foto: 'https://i.pravatar.cc/150?img=5',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 200.50,
        Fevereiro: 10500,
        Março: 13500,
        Abril: 12000,
        Maio: 15000,
        Junho: 18000,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 4,
    nome: 'Michael Pereira',
    email: 'michael.pereira@imobiliaria.com',
    telefone: '(11) 66666-6666',
    creci: 'CRECI-12348',
    foto: 'https://i.pravatar.cc/150?img=33',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 300.50,
        Fevereiro: 970,
        Março: 120,
        Abril: 100,
        Maio: 150,
        Junho: 500,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 5,
    nome: 'Nubia Pedroso',
    email: 'nubia.pedroso@imobiliaria.com',
    telefone: '(11) 55555-5555',
    creci: 'CRECI-12349',
    foto: 'https://i.pravatar.cc/150?img=9',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 42700.50,
        Fevereiro: 9000,
        Março: 150,
        Abril: 1000,
        Maio: 13500,
        Junho: 1500,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 6,
    nome: 'Juliana Ferreira',
    email: 'juliana.ferreira@imobiliaria.com',
    telefone: '(11) 44444-4444',
    creci: 'CRECI-12350',
    foto: 'https://i.pravatar.cc/150?img=47',
    ativo: false,
    vendas: {
      2026: {
        Janeiro: 5250,
        Fevereiro: 82500,
        Março: 100,
        Abril: 97,
        Maio: 100,
        Junho: 15000,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 7,
    nome: 'Roberto Alves',
    email: 'roberto.alves@imobiliaria.com',
    telefone: '(11) 33333-3333',
    creci: 'CRECI-12351',
    foto: 'https://i.pravatar.cc/150?img=68',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 450,
        Fevereiro: 750,
        Março: 900,
        Abril: 900,
        Maio: 1200,
        Junho: 100,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 8,
    nome: 'Fernanda Lima',
    email: 'fernanda.lima@imobiliaria.com',
    telefone: '(11) 22222-2222',
    creci: 'CRECI-12352',
    foto: 'https://i.pravatar.cc/150?img=20',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 300,
        Fevereiro: 500,
        Março: 900,
        Abril: 82,
        Maio: 1100,
        Junho: 1000,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 9,
    nome: 'Ricardo Souza',
    email: 'ricardo.souza@imobiliaria.com',
    telefone: '(11) 11111-1111',
    creci: 'CRECI-12353',
    foto: 'https://i.pravatar.cc/150?img=15',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 3300,
        Fevereiro: 900,
        Março: 100,
        Abril: 900,
        Maio: 100,
        Junho: 1500,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 10,
    nome: 'Patricia Rocha',
    email: 'patricia.rocha@imobiliaria.com',
    telefone: '(11) 10101-1010',
    creci: 'CRECI-12354',
    foto: 'https://i.pravatar.cc/150?img=25',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 200,
        Fevereiro: 800,
        Março: 900,
        Abril: 900,
        Maio: 120,
        Junho: 100,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 11,
    nome: 'Lucas Barbosa',
    email: 'lucas.barbosa@imobiliaria.com',
    telefone: '(11) 99999-8888',
    creci: 'CRECI-12355',
    foto: 'https://i.pravatar.cc/150?img=30',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 200,
        Fevereiro: 700,
        Março: 90,
        Abril: 80,
        Maio: 110,
        Junho: 500,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 12,
    nome: 'Camila Ribeiro',
    email: 'camila.ribeiro@imobiliaria.com',
    telefone: '(11) 88888-7777',
    creci: 'CRECI-12356',
    foto: 'https://i.pravatar.cc/150?img=35',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 2000,
        Fevereiro: 500,
        Março: 8200,
        Abril: 7000,
        Maio: 1000,
        Junho: 100,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 13,
    nome: 'Gabriel Almeida',
    email: 'gabriel.almeida@imobiliaria.com',
    telefone: '(11) 77777-6666',
    creci: 'CRECI-12357',
    foto: 'https://i.pravatar.cc/150?img=40',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 220,
        Fevereiro: 670,
        Março: 700,
        Abril: 700,
        Maio: 900,
        Junho: 1200,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 14,
    nome: 'Isabela Torres',
    email: 'isabela.torres@imobiliaria.com',
    telefone: '(11) 66666-5555',
    creci: 'CRECI-12358',
    foto: 'https://i.pravatar.cc/150?img=45',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 210000,
        Fevereiro: 67500,
        Março: 712500,
        Abril: 67500,
        Maio: 90000,
        Junho: 1125000,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 15,
    nome: 'Thiago Monteiro',
    email: 'thiago.monteiro@imobiliaria.com',
    telefone: '(11) 55555-4444',
    creci: 'CRECI-12359',
    foto: 'https://i.pravatar.cc/150?img=50',
    ativo: true,
    vendas: {
      2026: {
        Janeiro: 1950000,
        Fevereiro: 600000,
        Março: 675000,
        Abril: 637500,
        Maio: 825000,
        Junho: 1050000,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
  {
    id: 16,
    nome: 'Beatriz Cardoso',
    email: 'beatriz.cardoso@imobiliaria.com',
    telefone: '(11) 44444-3333',
    creci: 'CRECI-12360',
    foto: 'https://i.pravatar.cc/150?img=55',
    ativo: false,
    vendas: {
      2026: {
        Janeiro: 1800000,
        Fevereiro: 562500,
        Março: 637500,
        Abril: 600000,
        Maio: 750000,
        Junho: 975000,
        Julho: 0,
        Agosto: 0,
        Setembro: 0,
        Outubro: 0,
        Novembro: 0,
        Dezembro: 0,
      }
    }
  },
];

export const metaAnual = 25000000; // Meta total do ano R$ 25.000.000,00
